import { Component } from '@angular/core';

@Component({
  templateUrl: './without-permission.component.html',
  styleUrls: ['./without-permission.component.less'],
})
export class WithoutPermissionComponent {}
